module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAMAAABg3Am1AAAAUVBMVEUAAACSkpKXl5eZmZmZmZmZmZmVlZWXl5eYmJiZmZmZmZmZmZmZmZmUlJSZmZmYmJiZmZmZmZmXl5eXl5eZmZmYmJiZmZmYmJiYmJiYmJiZmZmp1fstAAAAGnRSTlMADTHk0PcaEYjv6XZfB8y23awqIcKdklFFOh+b6r4AAADKSURBVEjH7dTZCsMgEEBRs2hcmn2f///QwghN1Oq0FAqlOW9OvMQ8GPbELifNedEawV6xlfAw00k9w5laqf0TeEw66CFwYwk3CPGRRWUFIG3ySuxS2VVLvqARdikaux6IL1C4HwuNAxkNOv+5Ic7E8fl2DAZ7xGgASByDGgclEVSnyR8EPAh4OshQZPK5LCm4aVJBkjZuIMFD3TxNB40TAK24giv40YDTQen96Em9EyzvXtGR0ydyrUTRjcyTtxCnloqF6iGPEOyb7ggSbGuweCCdAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/login-password.png
// module id = M2b+
// module chunks = 1